import * as React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import "../../../assets/sass/components/myCart.scss";
import * as myCartActionCreators from "./actionCreators";
import * as multipleWarrantyThankyouActionCreators from "../MultipleWarrantiesThankYou/actionCreators";
import * as adminActionCreator from "../AdminDashboard/actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import { bindActionCreators } from "redux";
import {
    getAllParameters,
    getPersistData,
    setPersistData,
    setSessionValue,
    removeWindowBeforeUnload,
} from "../../utils/utils";
import CartItems from "./cartItems";
import Popup from "./Popup";
import AlertMessage from "../../widgets/AlertMessageWidget";
import MultipleWarrantiesAdjustCost from "../MultipleWarrantiesAdjustCost";
import { COPY_WARRANTY_DATA, CREATE_ANOTHER, WARRANTY_ERROR_CHECK } from "../../constants/storageKeys";
import { PersistData } from "../../middleware/persistDataMiddleware";
import Loader from "../Loader";
import ReviewPopup from "./ReviewPopup";
import { CART_STATUS } from "./constant";

class MyCartComponent extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            removeCartItemClicked: false,
            openAdjustCostPopup: false,
            openReviewPopup: false,
            showPopup: false,
            activeAction: null,
            warrantyId: null,
            deleteId: null,
        };
    }
    componentDidMount() {
        // todo implement later
        if (Object.keys(this.props.userInfo).length && this.props.cartId) {
            this.props.myCartActions.getCartItems({ cartId: this.props.cartId });
        }
    }
    componentDidUpdate(prevProps) {
        // todo implement later
        if (this.state.removeCartItemClicked && !this.props.isLoading) {
            this.setState({
                removeCartItemClicked: false,
            });
            this.props.myCartActions.getCartItems({ cartId: this.props.cartId });
        }
        if (
            prevProps.thankYouPageCartResponse !== this.props.thankYouPageCartResponse &&
            Object.keys(this.props.thankYouPageCartResponse).length > 0
        ) {
            this.props.history.push("/paymentsuccess");
        }
    }

    onConfirmAction = async () => {
        const { activeAction, warrantyId, deleteId } = this.state;
        const { cartId, myCartActions, globalActions } = this.props;
        if (activeAction === "remove") {
            myCartActions.deleteCartItem({ cartId, warrantyId: deleteId });
            this.setState({
                removeCartItemClicked: true,
                activeAction: null,
                warrantyId: null,
                deleteId: null,
                showPopup: false,
            });
            return;
        } else if (activeAction === "copy") {
            let persistData: PersistData = getPersistData() || {};
            persistData = Object.assign(persistData, {
                warrantyId,
            });
            setSessionValue(COPY_WARRANTY_DATA, "true");
            setSessionValue(CREATE_ANOTHER, "true");
            setPersistData(persistData);
        } else if (activeAction === "edit") {
            // removing the isVarienceRequest flag from session storage.
            if (sessionStorage.getItem('isVarianceRequested')) {
                sessionStorage.removeItem('isVarianceRequested');
            }
            await myCartActions.deleteCartItem({ cartId, warrantyId: deleteId });
            myCartActions.updateActiveAction({ activeAction, warrantyId });
            globalActions.updateActiveScreen("NewForm");
        } else if (activeAction === "delete") {
            const { adminActions, cartId } = this.props;
            adminActions.deleteShoppingCartClick({ cartId, successCallBack: this.redirectToDashboard });
            return;
        }
        setSessionValue(WARRANTY_ERROR_CHECK, "true");
        this.redirectToDashboard();
    };
    redirectToDashboard = () => {
        this.setState({
            activeAction: null,
            warrantyId: null,
            deleteId: null,
            showPopup: false,
        });
        const navigateToUrl = getAllParameters(this.props.userInfo);
        this.props.history.push(navigateToUrl);
    };
    onCancelAction = () => {
        if (this.state.openReviewPopup) {
            this.props.myCartActions.resetReviewWarrantyData();
        }
        this.setState({
            activeAction: null,
            warrantyId: null,
            deleteId: null,
            showPopup: false,
            openReviewPopup: false,
        });
    };
    editItem = (warrantyId, deleteId) => {
        console.log("edit Item", warrantyId);
        // this.props.myCartActions.updateActiveAction({ activeAction: "edit", warrantyId });
        // this.props.globalActions.updateActiveScreen("NewForm");
        this.setState({
            activeAction: "edit",
            warrantyId,
            deleteId,
            showPopup: true,
        });
    };

    reviewItem = (warrantyId) => {
        window.scrollTo(0, 0);
        this.props.myCartActions.reviewWarrantyData(warrantyId);
        this.setState({
            openReviewPopup: true,
        });
    };

    copyItem = (warrantyId) => {
        this.setState({
            activeAction: "copy",
            warrantyId,
            showPopup: true,
        });
    };

    deleteItem = (deleteId) => {
        this.setState({
            activeAction: "remove",
            deleteId,
            showPopup: true,
        });
    };

    createNew = () => {
        setSessionValue(CREATE_ANOTHER, "true");
        const navigateToUrl = getAllParameters(this.props.userInfo);
        this.props.history.push(navigateToUrl);
    };

    checkoutCartConfirm = () => {
        const { myCartActions, cartId } = this.props;
        myCartActions.beginTransaction({ cartId });
        this.setState({
            openAdjustCostPopup: false,
        });
    };

    hideAdjustCostPopup = () => {
        this.setState({
            openAdjustCostPopup: false,
        });
    };
    checkoutCart = () => {
        const { userInfo, myCartActions, cartId } = this.props;
        if (userInfo.isAdmin) {
            this.setState({
                openAdjustCostPopup: true,
            });
        } else {
            myCartActions.beginTransaction({ cartId });
        }
    };
    reSubmitCart = () => {
        const { myCartActions, cartId, totalAmount } = this.props;
        myCartActions.reSubmitCart({ cartId, IsResubmit: true, TotalShoppingCartCost: totalAmount });
    };
    refundCart = () => {
        this.setState({
            activeAction: "delete",
            showPopup: true,
        });
    };
    renderEmptyCart = () => {
        return (
            <>
                <div className="my-cart-content">
                    <div className="my-cart-title">My cart</div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-container">
                        <div className="gaf-search">
                            <Row>
                                <Col md={12}>
                                    <div className="d-flex justify-content-center">
                                        <p>You have no warranties in your cart</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="d-flex justify-content-center">
                                        <Button className="gaf-btn-primary create-new" onClick={this.createNew}>
                                            Create New
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </>
        );
    };
    renderCartItems = () => {
        const { totalCount, totalAmount, cartId, totalRefundAmount, isPartialCartRefund, userInfo } = this.props;
        const total: any = parseFloat(totalAmount) - parseFloat(totalRefundAmount);
        return (
            <>
                <div className="my-cart-content">
                    {this.state.showPopup ? (
                        <Popup
                            onConfirm={this.onConfirmAction}
                            onCancel={this.onCancelAction}
                            activeAction={this.state.activeAction}
                        />
                    ) : null}
                    {this.state.openReviewPopup && Object.keys(this.props.reviewData).length ? (
                        <ReviewPopup onCancel={this.onCancelAction} />
                    ) : null}
                    {this.state.openAdjustCostPopup ? (
                        <MultipleWarrantiesAdjustCost hidePopsUp={this.hideAdjustCostPopup} />
                    ) : null}
                    <div className="cart-container">
                        <div className="my-cart-title">
                            <div className="cart-title">
                                My Cart <span className="my-cart-id">({cartId})</span>
                            </div>
                            <div className="price-title">Price</div>
                        </div>
                        <div className="cart-items-container">
                            <CartItems
                                disableActions={this.props.cartStatus > CART_STATUS.CheckedOut}
                                items={this.props.cartItems}
                                editItem={this.editItem}
                                reviewItem={this.reviewItem}
                                copyItem={this.copyItem}
                                deleteItem={this.deleteItem}
                            />
                        </div>
                        <div
                            className={this.props.cartStatus > CART_STATUS.CheckedOut ? "d-none" : "my-cart-disclaimer"}
                        >
                            Please Note: Items left in cart will return to drafts nightly. Max cart size: 25.
                        </div>
                    </div>
                    <div className="desktop-cart my-cart-summary">
                        <div className="summary-title">Summary</div>
                        <div className="summary-content">
                            <div className="sub-total">
                                <div className="summary-amount-key">Items:&nbsp;</div>
                                <div className="summary-amount-value amount">{totalCount}</div>
                                <div className="summary-amount-key">Subtotal:&nbsp;</div>
                                <div className="summary-amount-value amount">
                                    ${`${parseFloat(totalAmount).toFixed(2)}`}
                                </div>
                                {userInfo.isAdmin && isPartialCartRefund ? (
                                    <>
                                        {totalRefundAmount !== 0 && (
                                            <>
                                                <div className="summary-amount-key">
                                                    Refunded:&nbsp;<span className="amount">-</span>
                                                </div>
                                                <div className="summary-amount-value amount">
                                                    ${`${parseFloat(totalRefundAmount).toFixed(2)}`}
                                                </div>
                                            </>
                                        )}

                                        <div className="summary-amount-key">
                                            Total:&nbsp;<span className="amount invisible">-</span>
                                        </div>
                                        <div className="summary-amount-value amount">
                                            ${`${parseFloat(total).toFixed(2)}`}
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {userInfo.isAdmin && this.props.cartStatus > CART_STATUS.CheckedOut ? (
                                <>
                                    {!isPartialCartRefund ? (
                                        <div className="checkout">
                                            <Button
                                                className={"btn gaf-btn-primary checkout-btn"}
                                                onClick={this.reSubmitCart}
                                            >
                                                ReSubmit
                                            </Button>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div className="checkout">
                                        <Button
                                            className={"btn gaf-btn-primary new-warranty-btn"}
                                            onClick={this.refundCart}
                                        >
                                            Delete Cart
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="checkout">
                                        <Button
                                            className={"btn gaf-btn-primary checkout-btn"}
                                            onClick={this.checkoutCart}
                                        >
                                            Checkout
                                        </Button>
                                    </div>
                                    <div className="checkout">
                                        <Button
                                            className={"btn gaf-btn-primary new-warranty-btn"}
                                            onClick={this.createNew}
                                        >
                                            New Warranty
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="mobile-cart my-cart-summary">
                    <div className="summary-content">
                        {userInfo.isAdmin && this.props.cartStatus > CART_STATUS.CheckedOut ? (
                            <>
                                <div className="summary-totals">
                                    <div className="summary-amount-key">{`Subtotal (${totalCount} items):`}&nbsp;</div>
                                    <div className="summary-amount-value amount">
                                        ${`${parseFloat(totalAmount).toFixed(2)}`}
                                    </div>
                                    {isPartialCartRefund ? (
                                        <>
                                            <div className="summary-amount-key">
                                                Refunded:&nbsp;<span className="amount">-</span>
                                            </div>
                                            <div className="summary-amount-value amount">
                                                ${`${parseFloat(totalRefundAmount).toFixed(2)}`}
                                            </div>
                                            <div className="summary-amount-key">
                                                Total:&nbsp;<span className="amount invisible">-</span>
                                            </div>
                                            <div className="summary-amount-value">
                                                ${`${parseFloat(total).toFixed(2)}`}
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="summary-actions">
                                    <div className={isPartialCartRefund ? "checkout invisible" : "checkout"}>
                                        <Button
                                            className={"btn gaf-btn-primary checkout-btn"}
                                            onClick={this.reSubmitCart}
                                        >
                                            ReSubmit
                                        </Button>
                                    </div>
                                    <div className="checkout">
                                        <Button
                                            className={"btn gaf-btn-primary new-warranty-btn"}
                                            onClick={this.refundCart}
                                        >
                                            Delete Cart
                                        </Button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="sub-total">
                                <div className="sub-total-detail">
                                    <div>{`Subtotal (${this.props.totalCount} items):`}</div>
                                    <div className="amount">${`${parseFloat(this.props.totalAmount).toFixed(2)}`}</div>
                                </div>
                                <div className="checkout">
                                    <Button className="btn gaf-btn-primary checkout-btn" onClick={this.checkoutCart}>
                                        Checkout
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    };
    render() {
        const { userInfo, isLoading, cartItems, cartId, beginTxData } = this.props;
        const show = Object.keys(userInfo).length;
        const containerClass = show && userInfo.isAdmin ? "admin-cart my-cart-container" : "my-cart-container";
        const navigateToUrl = getAllParameters(userInfo);
        if (beginTxData.proceedToPayment) {
            removeWindowBeforeUnload();
            setTimeout(() => {
                //removeSessionBeforeUnload();
                window.location.href = beginTxData.redirectUrl;
            }, 300);
        }
        return show ? (
            <main className={containerClass} id="my-cart">
                {isLoading ? <Loader /> : null}
                {this.props.showAlert ? (
                    <div className="alert-container">
                        <AlertMessage
                            type={this.props.success ? "success" : "error"}
                            message={this.props.message}
                            closeAlert={() => {
                                this.props.myCartActions.clearSuccessMsg();
                            }}
                        />
                    </div>
                ) : null}
                {!!cartId && cartItems.length > 0 ? this.renderCartItems() : this.renderEmptyCart()}
            </main>
        ) : (
            <Redirect to={`${navigateToUrl}`} />
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo || {},
        isLoading: state.myCartInfo.isLoading,
        success: state.myCartInfo.success,
        error: state.myCartInfo.errors,
        cartItems: state.myCartInfo.cartItems,
        isPartialCartRefund: state.myCartInfo.isPartialCartRefund || false,
        totalAmount: state.myCartInfo.totalAmount || 0,
        totalRefundAmount: state.myCartInfo.totalRefundAmount || 0,
        totalCount: state.myCartInfo.totalCount,
        reviewData: state.myCartInfo.reviewData || {},
        cartId: state.myCartInfo.cartId,
        cartStatus: state.myCartInfo.cartStatus,
        beginTxData: state.myCartInfo.beginTxData,
        thankYouPageCartResponse: state.myCartInfo.beginTxData.thankYouPageCartResponse || {},
        showAlert: state.myCartInfo.success,
        message: state.myCartInfo.successMsg,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        myCartActions: bindActionCreators(myCartActionCreators, dispatch),
        adminActions: bindActionCreators(adminActionCreator, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
        thankyouActions: bindActionCreators(multipleWarrantyThankyouActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyCartComponent);
